import { DESCRIPTOR_TYPE } from 'actionTypes';
import actionsFactory from 'utils/redux/baseEntitiesFactory/actions';
import reducerFactory from 'utils/redux/baseEntitiesFactory/reducer';
import sagasFactory from 'utils/redux/baseEntitiesFactory/sagas';
import thunkFactory from 'utils/redux/baseEntitiesFactory/thunk';

// ACTIONS
const rawActions = actionsFactory(DESCRIPTOR_TYPE);
const actions = { ...rawActions, ...thunkFactory(DESCRIPTOR_TYPE, '/descriptor_types/') };
export { actions };

// REDUCER
const initialState = {
  ids: [],
  models: {},
  loaded: false,
  loading: false,
  errorMessage: '',
  submitting: false
};

export default reducerFactory(DESCRIPTOR_TYPE, initialState);

// SAGAS
const sagas = sagasFactory(DESCRIPTOR_TYPE, '/descriptor_types/');
export { sagas };
